import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import AdminLayout from "../../components/admin/AdminLayout";

export default function AdminAnalytics() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchData(); }, []);

  async function fetchData() {
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/analytics?days=30`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("rs_token")}` },
      });
      if (!res.ok) throw new Error("Failed to load analytics");
      setData(await res.json());
    } catch (e) {
      toast.error(e.message);
    } finally {
      setLoading(false);
    }
  }

  const renderBars = (dataset, label) => {
    const vals = Object.values(dataset || {});
    const max = Math.max(...vals, 1);
    const entries = Object.entries(dataset || {}).slice(-14);

    return (
      <div className="card-pop p-4">
        <h3 className="font-bold mb-3">{label}</h3>
        {entries.length === 0 ? (
          <p className="text-sm text-[var(--ink-muted)] py-4 text-center">No data</p>
        ) : (
          <div className="flex items-end gap-1 h-32">
            {entries.map(([day, val]) => (
              <div key={day} className="flex-1 flex flex-col items-center gap-1 group">
                <div className="w-full rounded-sm bg-orange-500/80 group-hover:bg-orange-600 transition-all" style={{ height: `${(val / max) * 100}%` }} />
                <span className="text-[10px] text-[var(--ink-muted)]">{day.slice(5)}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <AdminLayout>
      <div className="space-y-5">
        {loading ? (
          <div className="flex items-center justify-center h-64"><div className="tag">Loading analytics...</div></div>
        ) : (
          <>
            <div className="grid lg:grid-cols-3 gap-4">
              {renderBars(data?.daily_scans, "Daily Scans")}
              {renderBars(data?.daily_spins, "Daily Spins")}
              {renderBars(data?.daily_redemptions, "Daily Redemptions")}
            </div>

            <div className="grid lg:grid-cols-2 gap-4">
              <div className="card-pop p-4">
                <h3 className="font-bold mb-3">Top Owners</h3>
                {(data?.top_owners || []).length === 0 ? (
                  <p className="text-sm text-[var(--ink-muted)] py-4 text-center">No data</p>
                ) : (
                  <div className="space-y-2">
                    {data.top_owners.map((o, i) => (
                      <div key={i} className="flex items-center justify-between p-2 rounded-lg bg-gray-50">
                        <div className="text-sm font-bold">{o.name}</div>
                        <div className="text-xs text-[var(--ink-muted)]">{o.total_scans} scans</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div className="card-pop p-4">
                <h3 className="font-bold mb-3">Top Outlets</h3>
                {(data?.top_outlets || []).length === 0 ? (
                  <p className="text-sm text-[var(--ink-muted)] py-4 text-center">No data</p>
                ) : (
                  <div className="space-y-2">
                    {data.top_outlets.map((o, i) => (
                      <div key={i} className="flex items-center justify-between p-2 rounded-lg bg-gray-50">
                        <div className="text-sm font-bold">{o.name}</div>
                        <div className="text-xs text-[var(--ink-muted)]">{o.total_scans} scans</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </AdminLayout>
  );
}